var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gr-body-medium",class:[_vm.item.isRead ? 'grey--text' : 'white--text']},[_c(_vm.itemComponent,{tag:"component",attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }